
import { openLoginModal } from '@/helpers/ModalDialogs'
import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class LoginModalStory extends Vue {
  mounted() {
    openLoginModal()
  }
}
